export default __webpack_public_path__ + "static/media/burger-bread-bottom.efcf9c83.svg";